export const contact = {
  it: {
    title: "Contattami",
    info: {
      title: "Informazioni di Contatto",
      whatsapp: {
        title: "WhatsApp",
        number: "+39 380 633 1704"
      },
      email: {
        title: "Email",
        address: "victor@victorlazari.com"
      },
      location: {
        title: "Sede",
        address: "San Pietro in Vinoli, Ravenna, 48125, Italia"
      },
      linkedin: {
        title: "LinkedIn",
        username: "Victor Lazari"
      }
    },
    whatsappButton: "Contattami su WhatsApp",
    map: {
      title: "La nostra sede",
      alt: "Mappa della sede di Victor Lazari"
    }
  },
  en: {
    title: "Get in Touch",
    info: {
      title: "Contact Information",
      whatsapp: {
        title: "WhatsApp",
        number: "+39 380 633 1704"
      },
      email: {
        title: "Email",
        address: "victor@victorlazari.com"
      },
      location: {
        title: "Location",
        address: "San Pietro in Vinoli, Ravenna, 48125, Italy"
      },
      linkedin: {
        title: "LinkedIn",
        username: "Victor Lazari"
      }
    },
    whatsappButton: "Contact Me on WhatsApp",
    map: {
      title: "Our Location",
      alt: "Victor Lazari's office location map"
    }
  }
};